import Serializable from './serializable';

export class Ticket extends Serializable {

	id: string;

	type: string;
}
